import React from 'react';
import { motion } from 'framer-motion';
import { CircleXIcon } from 'lucide-react';
const costs = ['Evenings lost searching for choreography ideas that actually work for your specific students', 'Classes that feel repetitive — because you keep going back to what you already know', 'Visible improvisation that silently chips away at your confidence as an instructor week after week', 'No real variety between sessions — and students who slowly lose motivation', 'Weekends spent planning instead of resting, recovering, or actually living your life', 'Walking into the studio wishing you had prepared more — again'];
export function PainPoints() {
  return <section className="bg-charcoal px-4 py-20 text-white sm:py-24" data-id="element-161">
      <div className="mx-auto max-w-3xl" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-163">
          <h2 className="font-display text-3xl font-bold sm:text-4xl" data-id="element-164">
            Does any of this sound familiar?
          </h2>
          <div className="mt-7 rounded-2xl border border-charcoal-line bg-charcoal-card p-6 text-left text-base leading-relaxed text-zinc-300" data-id="element-165">
            <p data-id="element-166">
              Sunday evening. 9 PM. You have a dance fitness class tomorrow
              morning.
            </p>
            <p className="mt-4" data-id="element-167">
              And you are still here — searching for choreography ideas, trying
              to build a routine that flows, fits your students, and feels
              energetic and professional.
            </p>
            <p className="mt-4 font-medium text-gold-light" data-id="element-168">
              Not because you are not a great instructor. Because nobody ever
              gave you a complete, ready-to-teach system.
            </p>
            <p className="mt-4" data-id="element-169">
              You have been building every single class from scratch. The time
              you should be resting, you spend planning. The worst part is
              walking into the studio feeling like you could have been better
              prepared.
            </p>
          </div>
        </motion.div>
        <div className="mt-12" data-id="element-170">
          <h3 className="mb-6 text-center text-lg font-bold" data-id="element-171">
            The real cost of not having the right resource:
          </h3>
          <ul className="space-y-3" data-id="element-172">
            {costs.map((item, index) => <motion.li key={item} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.07
          }} className="flex gap-3 rounded-xl border border-gold/15 bg-charcoal-card p-4 text-sm text-zinc-300" data-id="element-173">
                <CircleXIcon className="mt-0.5 shrink-0 text-gold-light" size={18} data-id="element-174" />
                {item}
              </motion.li>)}
          </ul>
        </div>
        <div className="mt-12 border-t border-charcoal-line pt-9 text-center" data-id="element-175">
          <p className="font-display text-2xl font-bold text-gold-light" data-id="element-176">
            Stop giving away your free time. What you need now is the right
            tool.
          </p>
          <p className="mt-3 text-lg text-white" data-id="element-177">
            Plan an entire year of classes — starting today.
          </p>
        </div>
      </div>
    </section>;
}